<template>
  <Loader :flag="flag.isLoading.get" :class="[s.wrap, !['production', 'develop'].includes(helper.env.name) ? s.isDevelop : '']">
    <div v-if="!flag.isLoading.get">
      <ul>
        <li
          v-for="vehicle in vehicles"
          :key="vehicle.id"
          class="bdr-b"
          :class="selectedVehicleId === vehicle.id ? s.selected : ''"
          @click="selectedVehicleId = vehicle.id">
          <div
            class="d-flex justify-content-between align-items-center p-3">
            <div class="d-flex align-items-center">
              <i class="fa-solid fa-car"/>
              <div class="ms-3">
                <div>{{ vehicle.label }}</div>
                <div>{{ vehicle.name }}</div>
                <div>{{ vehicle.number }}</div>
              </div>
            </div>
            <div :class="s.circle"/>
          </div>
        </li>
        <li
          class="bdr-b"
          :class="!selectedVehicleId ? s.selected : ''"
          @click="selectedVehicleId = 0">
          <div
            class="d-flex justify-content-between align-items-center p-3">
            <div class="d-flex align-items-center">
              <i class="fa-solid fa-car"/>
              <div class="ms-3">車両指定なし</div>
            </div>
            <div :class="s.circle"/>
          </div>
        </li>
      </ul>
      <div :class="[
          s.submit,
          !['production', 'develop'].includes(helper.env.name) ? s.isDevelop : '',
          helper.isNative.app ? s.isNative : '',
        ]">
        <large-btn
          :disabled="!readySubmit"
          @click="submit"><i class="fa-regular fa-download me-2"/>変更する
        </large-btn>
      </div>
    </div>

    <!-- 車両登録 -->
    <div class="bdr-b rounded-2" v-if="user?.role?.role === 13">
      <div class="d-flex align-items-center justify-content-between px-4 pt-4">
        <div class="fw-bold">新規車両登録</div>
        <div class="d-flex">
          <button
            type="button"
            class="btn btn-success btn-sm"
            :disabled="!flag.readyRegistVehicle"
            @click="registVehicle(1)"><i class="fa-regular fa-download me-2"/>登録する</button>
        </div>
      </div>
      <div class="px-4 py-3">
        <Form
          v-model:items="vehicleBaseData"
          @changeSubmitFlag="changeFormSubmitFlag" />
      </div>
    </div>
  </Loader>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/components/parts/Loader';
import LargeBtn from '@/components/parts/LargeBtn';
import Form from '@/components/parts/Form'; // Formは個別に読み込まないとエラーになる
import cf from '@/mixins/commonFunctions';

export default {
  name: 'change-vehicle-form',
  components: {
    LargeBtn,
    Loader,
    Form,
  },
  mixins: [cf],
  data() {
    return {
      flag: {
        isLoading: {
          get: true,
        },
        readyRegistVehicle: false,
      },
      vehicles: [],
      selectedVehicleId: 0,
      vehicleBaseData: [
        {
          name: 'name',
          label: '車名',
          type: 'text',
          required: true,
          value: '',
        },
        {
          name: 'capacity',
          label: '乗員定員',
          type: 'number',
          required: true,
          value: '',
        },
        {
          name: 'number',
          label: 'ナンバー',
          type: 'text',
          required: true,
          value: '',
        },
      ],
    };
  },
  created() {
    this.selectedVehicleId = this.user.vehicles[0]?.id || 0;
    this.getVehicles();
  },
  computed: {
    ...mapState(['user', 'helper']),
    readySubmit() {
      return this.selectedVehicleId !== null && this.selectedVehicleId !== (this.currentVehicle?.id || 0);
    },
    officeId() {
      return this.user.offices?.[0]?.id || 0;
    },
    currentVehicle() {
      return this.user.vehicles?.[0] || {};
    },
  },
  watch: {
    user: {
      handler() {
        this.getVehicles();
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getVehicles() {
      this.flag.isLoading.get = true;
      this.vehicles = this.user.vehicles;
      const params = {
        onlyDriverless: 1,
        office_id: this.officeId,
      };
      if (this.user.role.role === 13) {
        params.isAppDriver = 1;
        params.user_id = this.user.id;
      }
      this.axios({
        method: 'GET',
        url: '/v1/vehicle/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.vehicles = [
            ...this.vehicles,
            ...res.vehicles.data,
          ];
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.flag.isLoading.get = false;
        });
    },

    submit() {
      this.showLoading();
      const data = {
        flag: 1,
        user_id: this.user.id,
        vehicle_id: this.selectedVehicleId,
      };

      this.axios({
        method: 'POST',
        url: '/v1/userVehicle/create',
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.exists) {
            alert('選択された車両は別のユーザーによって使用されているため設定できませんでした。\n該当車両の担当者に車両変更するよう依頼するか、管理者へお問い合わせください。');
            this.getVehicles();
            return;
          }
          alert('車両を変更しました');
          this.$store.dispatch('user/update');
        })
        .catch((error) => {
          alert('車両の変更に失敗しました。\n再度お試しください。');
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.hideLoading();
          this.$emit('changedVehicle');
        });
    },

    changeFormSubmitFlag(bool) {
      this.flag.readyRegistVehicle = bool;
    },

    initRegistVehicleForm() {
      this.vehicleBaseData.forEach((item) => {
        item.value = '';
      });
    },

    registVehicle(flag) {
      this.showLoading();
      const data = {
        flag,
        ...cf.pullOutValues(this.vehicleBaseData),
        user_id: this.user.id,
        is_rideshare: this.user.role?.role === 13 ? 1 : 0,
      };

      this.axios({
        method: 'POST',
        url: '/v1/vehicle/create/',
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.vehicleId) {
            this.initRegistVehicleForm();
            if (confirm('車両登録が完了しました。\n乗車車両を今回登録した車両に変更しますか？')) {
              this.selectedVehicleId = res.vehicleId;
              this.submit();
            } else {
              this.hideLoading();
            }
          }
          this.getVehicles();
        })
        .catch((error) => {
          alert('車両登録中にエラーが発生しました。\n再度お試しいただくか、管理者へお問い合わせください。');
          if (error.response) console.log(error.response.data);
          console.log(error);
          this.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  padding-bottom: 100px;
  &.isDevelop {
    padding-bottom: 150px;
  }
}
.circle {
  width: 30px;
  height: 30px;
  border-radius: 30px;
  border: 1px solid var(--border-gray);
  position: relative;
}
.selected {
  background-color: rgba(#0D6EFD, .1);
  i {
    color: var(--primary-blue);
  }
  .circle {
    &::after {
      content: '';
      position: absolute;
      top: 20%; left: 20%;
      width: 60%;
      height: 60%;
      background-color: var(--primary-blue);
      border-radius: 60%;
    }
  }
}
.submit {
  position: fixed;
  bottom: var(--footer-height);
  left: 0px;
  width: 100%;
  background-color: rgba(#ffffff, .2);
  padding: 8px;
  z-index: 10;
  
  &.isDevelop {
    bottom: calc(var(--footer-height) + 50px);
  }
    
  &.isNative {
    bottom: 0;
  }
}
</style>
